export default __webpack_public_path__ + "static/media/amazon.98d46b2a.png";